import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";
import {
	getErrorText,
	isDomMutationError,
	isTransientLoadError,
	reloadOnce,
	renderApplicationErrorHtml
} from "./utils/appErrorRecovery";

const reloadOnceAfterDomMutation = (errorMessage) => {
	if (!isDomMutationError(errorMessage)) {
		return false;
	}

	return reloadOnce("flowch_dom_mutation_reload");
};

const appAlreadyMounted = () => {
	const root = document.getElementById("root");
	return Boolean(root?.childElementCount);
};

const handleRecoverableLoadError = errorMessage => {
	if (reloadOnceAfterDomMutation(errorMessage)) {
		return;
	}

	if (isTransientLoadError(errorMessage)) {
		if (reloadOnce("flowch_transient_load_reload", 1200)) {
			return;
		}

		if (appAlreadyMounted()) {
			console.warn("Flowch Talk transient load error", errorMessage);
			return;
		}
	}

	const root = document.getElementById("root");
	if (!root) return;

	root.innerHTML = renderApplicationErrorHtml({
		errorText: errorMessage,
		transient: isTransientLoadError(errorMessage)
	});
};

window.addEventListener("error", (event) => {
	if (event?.error) {
		handleRecoverableLoadError(getErrorText(event.error || event.message));
	}
});

window.addEventListener("unhandledrejection", (event) => {
	const reason = event?.reason;
	const errorText = getErrorText(reason);

	if (isTransientLoadError(reason)) {
		event.preventDefault();
	}

	handleRecoverableLoadError(errorText);
});

try {
	ReactDOM.render(
		<CssBaseline>
			<App />
		</CssBaseline>,
		document.getElementById("root")
	);
} catch (err) {
	handleRecoverableLoadError(getErrorText(err));
}

if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/sw.js").catch(() => {
			// Service worker registration is optional for non-PWA environments.
		});
	});
}

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
